import { render, staticRenderFns } from "./groupTypeManagement.vue?vue&type=template&id=fd4cad08&scoped=true"
import script from "./groupTypeManagement.vue?vue&type=script&lang=js"
export * from "./groupTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./groupTypeManagement.vue?vue&type=style&index=0&id=fd4cad08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4cad08",
  null
  
)

export default component.exports